import React, { useState, useRef, useEffect } from "react";
import { FaSync, FaPrint } from "react-icons/fa";
import { Button, useDisclosure, Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import ListClass from "./ListClass";
import Print_pdf_class_list from "./Print_pdf_class_list";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Class = () => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [classData, setClassData] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef(); // Reference to Print_pdf_class_list component

  useEffect(() => {
    fetchClassData();
  }, []);

  const handleClick = () => {
    navigate("/teachers/add");
  };

  const fetchClassData = async () => {
    try {
      const school_id = sessionStorage.getItem('school_id'); // If JWT is needed

      const response = await fetch(
        `${BASE_URL}/admin/class/list_all_class.php?school_id=${school_id}`
      );
      const data = await response.json();
      console.log("Fetched Data:", data);
      if (data && data.success && Array.isArray(data.data)) {
        setClassData(data.data);
        setIsDataLoaded(true); // Mark data as loaded
      }
    } catch (error) {
      console.error("Error fetching class data:", error);
    }
  };

  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };

  return (
    <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
      <div className="teacher-list-container">
        <div className="header">
          <h1 style={{fontSize:'20px'}}>Class List</h1>
          <div className="action-buttons">
            <Button
              className="export-button"
              display={{ base: "none", md: "flex" }}
              backgroundColor="white"
              fontSize="11px"
              boxShadow="md"
              onClick={handlePrint} // Attach the print handler here
            >
              <FaPrint color="#515B73" />
              Print PDF
            </Button>
          </div>
        </div>

        <div className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Class</span> / <span>Class List</span>
        </div>
      </div>

      <div id="teacher-list-content">
        <ListClass />
      </div>

      {/* Include Print_pdf_class_list but keep it hidden on the UI */}
      <div style={{ display: "none" }}>
        <Print_pdf_class_list ref={printComponentRef} classData={classData} />
      </div>
    </div>
    
  );
};

export default Class;
